// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_lUx","cls2":"YourPaperCard-cls2_Dwz YourPaperCard-cls1_lUx"};